import hcAxios, { RequestOptions } from 'core/utils/hcAxios'
import { TResponse } from 'core/service/hcResponse'
// Web3钱包相关接口
enum API {
  // 分页查询主网
  Web3WalletChainPage = '/hk-web/web3/wallet/chain/page',
  // 获取配置
  Web3WalletGetConfig = '/hk-web/web3/wallet/get/config',
  // 保存用户登陆日志
  Web3WalletSavaLoginLog = '/hk-web/web3/wallet/sava/login/log',
  // 保存用户钱包
  Web3WalletSavaUserWallet = '/hk-web/web3/wallet/sava/user/wallet',
  // 分页查询币种
  Web3WalletTokenPage = '/hk-web/web3/wallet/token/page',
  // app扫码确认信息
  Web3WalletConfirmQrcode = '/hk-web/web3/wallet/confirm/qrcode',
  // app扫码后将qrCodeToken与钱包绑定
  Web3WalletDetermine = '/hk-web/web3/wallet/determine',
  // 生成扫码登录二维码token,前端获取到该token之后生成二维码图片
  Web3WalletGenerateQrcode = '/hk-web/web3/wallet/generate/qrcode',
  // ajax定时请求是否有用户扫描了二维码
  Web3WalletScanLogin = '/hk-web/web3/wallet/scan/login',
  // 查询所有主网
  Web3WalletChainAll = '/hk-web/web3/wallet/chain/all',
  // 查询所有币种
  Web3WalletTokenAll = '/hk-web/web3/wallet/token/all',
  // 查询钱包ID下面的账户数据
  Web3WalletAccountDataList = '/hk-web/web3/wallet/account/data/list',
  // 改变状态主网
  Web3WalletChangeStatusChain = '/hk-web/web3/wallet/change/status/chain',
  // 改变状态币种
  Web3WalletChangeStatusToken = '/hk-web/web3/wallet/change/status/token',
  // 逻辑删除主网
  Web3WalletRemoveChain = '/hk-web/web3/wallet/remove/chain',
  // 逻辑删除数据币种
  Web3WalletRemoveToken = '/hk-web/web3/wallet/remove/token',
  // 保存或更新主网
  Web3WalletSavaChain = '/hk-web/web3/wallet/sava/chain',
  // 保存或更新币种
  Web3WalletSavaToken = '/hk-web/web3/wallet/sava/token',
  // 更新配置
  Web3WalletUpdateConfig = '/hk-web/web3/wallet/update/config',
  // 分页查询用户数据
  Web3WalletUserDataPage = '/hk-web/web3/wallet/user/data/page',
  // 分页查询dex币种
  Web3WalletDexTokenPage = '/hk-web/web3/wallet/dex/token/page',
}

export type TGetWeb3WalletChainPageParams = {
  chainName?: any // 链名称
  chainNetworkId?: any // 链id
  chainType?: any // 链类型
  count?: any // 是否返回总记录数，默认true
  pageNum?: any // 页码
  pageSize?: any // 每页显示条数
  status?: any
}
export type TGetWeb3WalletChainPageResponse = TResponse<
  {
    apiChainIndex?: string // okx-web3os-api下定义的链索引
    chainDescription?: string // 链描述信息
    chainId?: number // chainId
    chainName?: string // 链名称
    chainNetworkId?: string // 链id
    chainRank?: number // 链展示排序
    chainType?: string // 链类型
    createdTime?: number // 创建时间
    derivedPath?: string // bip44/84 主链路径
    explorerApi?: string // 区块浏览器API接口
    explorerUrl?: string // 区块浏览器链接
    feeTokenId?: number // 手续费代币id
    logo?: string // logo
    mainTokenId?: number // 主代币id
    memoMode?: number // 是否memo模式  0-否 1-是
    protocolVersion?: string // 协议版本
    rpcHosts?: string[] // 节点rpc链接
    status?: number // 状态 0-关闭 1-开启
    testnetMode?: number // 是否测试网 0-否 1-是
    updatedBy?: string // 编辑人
    updatedTime?: number // 更新时间
    walletImportFormat?: string // 私钥/钱包导入格式
    website?: string // 官方网址
  }[]
>
export const getWeb3WalletChainPage = (params?: TGetWeb3WalletChainPageParams, options?: RequestOptions) => {
  return hcAxios.get<TGetWeb3WalletChainPageResponse>(API.Web3WalletChainPage, { params, options })
}

export type TGetWeb3WalletGetConfigParams = any
export type TGetWeb3WalletGetConfigResponse = TResponse<{
  reportWalletInfo?: number // 上报钱包信息: 0否 ，1是
  showTestnet?: number // 展示测试网络: 0否 ，1是
}>
export const getWeb3WalletGetConfig = (params?: TGetWeb3WalletGetConfigParams, options?: RequestOptions) => {
  return hcAxios.get<TGetWeb3WalletGetConfigResponse>(API.Web3WalletGetConfig, { params, options })
}

export type TPostWeb3WalletSavaLoginLogParams = {
  loginDevice?: string // 登录设备
  loginIp?: string // 登录ip
  walletId?: string // 钱包id
}
export type TPostWeb3WalletSavaLoginLogResponse = TResponse<any>
export const postWeb3WalletSavaLoginLog = (params?: TPostWeb3WalletSavaLoginLogParams, options?: RequestOptions) => {
  return hcAxios.post<TPostWeb3WalletSavaLoginLogResponse>(API.Web3WalletSavaLoginLog, params, { options })
}

export type TPostWeb3WalletSavaUserWalletParams = {
  accountId?: number // 账户id
  allAddresses?: string // 所有地址(json，eth:[xxx,aaa,bbb])
  chainsUsed?: string // 使用的链(数组或者,隔开)，有资产
  totalAddresses?: number // 地址数量
  totalAssets?: string // 用户总资产
  uid?: number // 关联平台uid
  walletId?: string // 钱包id
}
export type TPostWeb3WalletSavaUserWalletResponse = TResponse<any>
export const postWeb3WalletSavaUserWallet = (
  params?: TPostWeb3WalletSavaUserWalletParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostWeb3WalletSavaUserWalletResponse>(API.Web3WalletSavaUserWallet, params, { options })
}

export type TGetWeb3WalletTokenPageParams = {
  chainId?: any // 所属主网（关联外键）
  count?: any // 是否返回总记录数，默认true
  pageNum?: any // 页码
  pageSize?: any // 每页显示条数
  parentTokenId?: any // 父币种
  status?: any
  tokenName?: any // 币种名称
  tokenSymbol?: any // 币种简称
}
export type TGetWeb3WalletTokenPageResponse = TResponse<
  {
    chainId?: number // 所属主网（关联外键）
    cmcId?: number // 和cmc关联
    contractAddress?: string // 合约地址
    createdTime?: number // 创建时间
    decimal?: number // 币种精度
    logo?: string // logo
    parentTokenId?: number // 父币种
    status?: number // 状态 0-关闭 1-开启
    tokenDescription?: string // 介绍信息
    tokenId?: number // tokenId
    tokenName?: string // 币种名称
    tokenRank?: number // 代币展示排序
    tokenSymbol?: string // 币种简称
    tokenType?: string // 代币类型
    updatedBy?: string // 编辑人
    updatedTime?: number // 更新时间
    website?: string // 官方网址
  }[]
>
export const getWeb3WalletTokenPage = (params?: TGetWeb3WalletTokenPageParams, options?: RequestOptions) => {
  return hcAxios.get<TGetWeb3WalletTokenPageResponse>(API.Web3WalletTokenPage, { params, options })
}

export type TGetWeb3WalletConfirmQrcodeParams = {
  qrCodeToken?: any // qrCodeToken
}
export type TGetWeb3WalletConfirmQrcodeResponse = TResponse<any>
export const getWeb3WalletConfirmQrcode = (params?: TGetWeb3WalletConfirmQrcodeParams, options?: RequestOptions) => {
  return hcAxios.get<TGetWeb3WalletConfirmQrcodeResponse>(API.Web3WalletConfirmQrcode, { params, options })
}

export type TPostWeb3WalletDetermineParams = {
  accountId?: string // 账户id
  accountName?: string // 账户名称
  qrCodeToken?: string // QR code
  walletName?: string // 钱包Name
}
export type TPostWeb3WalletDetermineResponse = TResponse<any>
export const postWeb3WalletDetermine = (params?: TPostWeb3WalletDetermineParams, options?: RequestOptions) => {
  return hcAxios.post<TPostWeb3WalletDetermineResponse>(API.Web3WalletDetermine, params, { options })
}

export type TGetWeb3WalletGenerateQrcodeParams = any
export type TGetWeb3WalletGenerateQrcodeResponse = TResponse<{
  businessType?: number // 业务类型 0:app登陆 ，1:web3登陆
  qrCodeToken?: string // 二维码token
}>
export const getWeb3WalletGenerateQrcode = (params?: TGetWeb3WalletGenerateQrcodeParams, options?: RequestOptions) => {
  return hcAxios.get<TGetWeb3WalletGenerateQrcodeResponse>(API.Web3WalletGenerateQrcode, { params, options })
}

export type TGetWeb3WalletScanLoginParams = {
  qrCodeToken?: any // qrCodeToken
}
export type TGetWeb3WalletScanLoginResponse = TResponse<{
  accountId?: string // 账户accountid
  accountName?: string // 账户名称
  device?: string // 设备
  ip?: string // ip地址
  walletName?: string // 钱包Name
}>
export const getWeb3WalletScanLogin = (params?: TGetWeb3WalletScanLoginParams, options?: RequestOptions) => {
  return hcAxios.get<TGetWeb3WalletScanLoginResponse>(API.Web3WalletScanLogin, { params, options })
}

export type TGetWeb3WalletChainAllParams = {
  chainName?: any // 链名称
  chainNetworkId?: any // 链id
  chainType?: any // 链类型
  status?: any
}
export type TGetWeb3WalletChainAllResponse = TResponse<
  {
    apiChainIndex?: string // okx-web3os-api下定义的链索引
    chainDescription?: string // 链描述信息
    chainName?: string // 链名称
    chainNetworkId?: string // 链id
    chainRank?: number // 链展示排序
    chainType?: string // 链类型
    createdTime?: number // 创建时间
    explorerApi?: string // 区块浏览器API接口
    explorerUrl?: string // 区块浏览器链接
    feeTokenId?: number // 手续费代币id
    chainId?: number // id
    logo?: string // logo
    mainTokenId?: number // 主代币id
    memoMode?: number // 是否memo模式  0-否 1-是
    protocolVersion?: string // 协议版本
    rpcHosts?: string[] // 节点rpc链接
    status?: number // 状态 0-关闭 1-开启
    testnetMode?: number // 是否测试网 0-否 1-是
    updatedBy?: string // 编辑人
    updatedTime?: number // 更新时间
    walletImportFormat?: string // 私钥/钱包导入格式
    website?: string // 官方网址
    derivedPath?: string // bip44/84 主链路径
  }[]
>
export const getWeb3WalletChainAll = (params?: TGetWeb3WalletChainAllParams, options?: RequestOptions) => {
  return hcAxios.get<TGetWeb3WalletChainAllResponse>(API.Web3WalletChainAll, { params, options })
}

export type TGetWeb3WalletTokenAllParams = {
  chainId?: any // 所属主网（关联外键）
  parentTokenId?: any // 父币种
  status?: any
  tokenName?: any // 币种名称
  tokenSymbol?: any // 币种简称
}
export type TGetWeb3WalletTokenAllResponse = TResponse<
  {
    chainId?: number // 所属主网（关联外键）
    cmcId?: number // 和cmc关联
    contractAddress?: string // 合约地址
    createdTime?: number // 创建时间
    decimal?: number // 币种精度
    tokenId?: number // id
    logo?: string // logo
    parentTokenId?: number // 父币种
    status?: number // 状态 0-关闭 1-开启
    tokenDescription?: string // 介绍信息
    tokenName?: string // 币种名称
    tokenRank?: number // 代币展示排序
    tokenSymbol?: string // 币种简称
    tokenType?: string // 代币类型
    updatedBy?: string // 编辑人
    updatedTime?: number // 更新时间
    website?: string // 官方网址
    apiChainIndex?: string // okx-web3os-api下定义的链索引
  }[]
>
export const getWeb3WalletTokenAll = (params?: TGetWeb3WalletTokenAllParams, options?: RequestOptions) => {
  return hcAxios.get<TGetWeb3WalletTokenAllResponse>(API.Web3WalletTokenAll, { params, options })
}

export type TGetWeb3WalletAccountDataListParams = {
  walletId?: any // walletId
}
export type TGetWeb3WalletAccountDataListResponse = TResponse<
  {
    accountId?: number // 账户ID
    allAddresses?: string // 关联地址
    chainsUsed?: string // 关联主网
  }[]
>
export const getWeb3WalletAccountDataList = (
  params?: TGetWeb3WalletAccountDataListParams,
  options?: RequestOptions
) => {
  return hcAxios.get<TGetWeb3WalletAccountDataListResponse>(API.Web3WalletAccountDataList, { params, options })
}

export type TPostWeb3WalletChangeStatusChainParams = {
  id?: number // id
  status?: number // 状态 0-关闭 1-开启
  updatedBy?: string
}
export type TPostWeb3WalletChangeStatusChainResponse = TResponse<any>
export const postWeb3WalletChangeStatusChain = (
  params?: TPostWeb3WalletChangeStatusChainParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostWeb3WalletChangeStatusChainResponse>(API.Web3WalletChangeStatusChain, params, { options })
}

export type TPostWeb3WalletChangeStatusTokenParams = {
  id?: number // id
  status?: number // 状态 0-关闭 1-开启
  updatedBy?: string
}
export type TPostWeb3WalletChangeStatusTokenResponse = TResponse<any>
export const postWeb3WalletChangeStatusToken = (
  params?: TPostWeb3WalletChangeStatusTokenParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostWeb3WalletChangeStatusTokenResponse>(API.Web3WalletChangeStatusToken, params, { options })
}

export type TPostWeb3WalletRemoveChainParams = {
  id?: number // id
  updatedBy?: string
}
export type TPostWeb3WalletRemoveChainResponse = TResponse<any>
export const postWeb3WalletRemoveChain = (params?: TPostWeb3WalletRemoveChainParams, options?: RequestOptions) => {
  return hcAxios.post<TPostWeb3WalletRemoveChainResponse>(API.Web3WalletRemoveChain, params, { options })
}

export type TPostWeb3WalletRemoveTokenParams = {
  id?: number // id
  updatedBy?: string
}
export type TPostWeb3WalletRemoveTokenResponse = TResponse<any>
export const postWeb3WalletRemoveToken = (params?: TPostWeb3WalletRemoveTokenParams, options?: RequestOptions) => {
  return hcAxios.post<TPostWeb3WalletRemoveTokenResponse>(API.Web3WalletRemoveToken, params, { options })
}

export type TPostWeb3WalletSavaChainParams = {
  apiChainIndex?: string // okx-web3os-api下定义的链索引
  chainDescription?: string // 链描述信息
  chainName?: string // 链名称
  chainNetworkId?: string // 链id
  chainRank?: number // 链展示排序
  chainType?: string // 链类型
  derivedPath?: string // bip44/84 主链路径
  explorerApi?: string // 区块浏览器API接口
  explorerUrl?: string // 区块浏览器链接
  feeTokenId?: number // 手续费代币id
  id?: number // id ：更新为必须，新增为非必须
  logo?: string // logo
  mainTokenId?: number // 主代币id
  memoMode?: number // 是否memo模式  0-否 1-是
  protocolVersion?: string // 协议版本
  rpcHosts?: string // 节点rpc链接
  status?: number // 状态 0-关闭 1-开启
  testnetMode?: number // 是否测试网 0-否 1-是
  updatedBy?: string
  walletImportFormat?: string // 私钥/钱包导入格式
  website?: string // 官方网址
}
export type TPostWeb3WalletSavaChainResponse = TResponse<any>
export const postWeb3WalletSavaChain = (params?: TPostWeb3WalletSavaChainParams, options?: RequestOptions) => {
  return hcAxios.post<TPostWeb3WalletSavaChainResponse>(API.Web3WalletSavaChain, params, { options })
}

export type TPostWeb3WalletSavaTokenParams = {
  chainId?: number // 所属主网（关联外键）
  cmcId?: number // 和cmc关联
  contractAddress?: string // 合约地址
  decimal?: number // 币种精度
  id?: number // id ：更新为必须，新增为非必须
  logo?: string // logo
  parentTokenId?: number // 父币种
  status?: number // 状态 0-关闭 1-开启
  tokenDescription?: string // 介绍信息
  tokenName?: string // 币种名称
  tokenRank?: number // 代币展示排序
  tokenSymbol?: string // 币种简称
  tokenType?: string // 代币类型
  updatedBy?: string
  website?: string // 官方网址
}
export type TPostWeb3WalletSavaTokenResponse = TResponse<any>
export const postWeb3WalletSavaToken = (params?: TPostWeb3WalletSavaTokenParams, options?: RequestOptions) => {
  return hcAxios.post<TPostWeb3WalletSavaTokenResponse>(API.Web3WalletSavaToken, params, { options })
}

export type TPostWeb3WalletUpdateConfigParams = {
  reportWalletInfo?: number // 上报钱包信息: 0否 ，1是
  showTestnet?: number // 展示测试网络: 0否 ，1是
}
export type TPostWeb3WalletUpdateConfigResponse = TResponse<any>
export const postWeb3WalletUpdateConfig = (params?: TPostWeb3WalletUpdateConfigParams, options?: RequestOptions) => {
  return hcAxios.post<TPostWeb3WalletUpdateConfigResponse>(API.Web3WalletUpdateConfig, params, { options })
}

export type TGetWeb3WalletUserDataPageParams = {
  count?: any // 是否返回总记录数，默认true
  loginDevice?: any // 最近访问设备
  loginIp?: any // 最近访问IP
  loginTimeEnd?: any // 结束访问时间
  loginTimeStart?: any // 开始访问时间
  pageNum?: any // 页码
  pageSize?: any // 每页显示条数
}
export type TGetWeb3WalletUserDataPageResponse = TResponse<
  {
    id?: number // id
    loginDevice?: string // 最近访问设备
    loginIp?: string // 最近访问IP
    totalAddresses?: number // 地址数量
    totalAssets?: string // 用户总资产
    updatedTime?: number // 更新时间
    walletId?: string // 钱包ID
  }[]
>
export const getWeb3WalletUserDataPage = (params?: TGetWeb3WalletUserDataPageParams, options?: RequestOptions) => {
  return hcAxios.get<TGetWeb3WalletUserDataPageResponse>(API.Web3WalletUserDataPage, { params, options })
}

export type TGetWeb3WalletDexTokenPageParams = {
  chainId?: any // chain_id
  contractAddress?: any // 合约地址
  count?: any // 是否返回总记录数，默认true
  datasource?: any // datasource
  pageNum?: any // 页码
  pageSize?: any // 每页显示条数
  status?: any
  tokenSymbol?: any // 币种简称
}
export type TGetWeb3WalletDexTokenPageResponse = TResponse<
  {
    chainId?: number // 所属主网（关联外键）
    contractAddress?: string // 合约地址
    createdTime?: number // 创建时间
    datasource?: string // 数据来源
    decimal?: number // 币种精度
    dexTokenId?: number // dexTokenId,dex表的主键自增id
    logo?: string // logo
    status?: number // 状态 0-关闭 1-开启
    tokenName?: string // 币种名称
    tokenRank?: number // 代币展示排序
    tokenSymbol?: string // 币种简称
    updatedBy?: string // 编辑人
    updatedTime?: number // 更新时间
  }[]
>
export const getWeb3WalletDexTokenPage = (params?: TGetWeb3WalletDexTokenPageParams, options?: RequestOptions) => {
  return hcAxios.get<TGetWeb3WalletDexTokenPageResponse>(API.Web3WalletDexTokenPage, { params, options })
}
